<template lang="html">
<div class="tablepanel">
<div class="new">
  <div class="table">
    <div class="table-header">
    <div class="table-row paddingleft">
      <div class="table-th w150">Consignee</div>
      <div class="table-th w150">Ref Id</div>
      <div class="table-th w150">LR Number</div>
      <div class="table-th w100">Weight</div>
      <div class="table-th w100">Volume</div>
      <div class="table-th w100">Material Invoice</div>
    </div>
  </div>
  <div class="table-bgcolor">
  <div class="table-row table-rowbg paddingleft" v-for="consignee in indentDetails.consignee_details">
    <div class="table-td w150">
      <Ellipsis v-if="consignee.company_name"
        :text="consignee.company_name"
        :length="20" />
    </div>
    <div class="table-td w150">{{consignee.ref_id}}</div>
    <div class="table-td w150 table-td-break">
        <Ellipsis v-if="consignee.lr_number.toString().length"
        :text="consignee.lr_number.toString()"
        :length="13" />
    </div>
    <div class="table-td w100">{{ consignee.weight !== '-'? consignee.weight.toFixed(2):consignee.weight}}</div>
    <div class="table-td w100">{{ consignee.volume !== '-'? consignee.volume.toFixed(2):consignee.volume}}</div>
    <div class="table-td w100">
      {{consignee.materialInvoiceNumbers.join(', ')}}
<!--      <Ellipsis :text="consignee.materialInvoiceNumbers.join(', ')" :length="5"/>-->
<!--      <span v-if="consignee.materialInvoiceNumbers.length>1">+-->
<!--        {{consignee.materialInvoiceNumbers.length-1}}</span>-->
    </div>
  </div>
</div>
</div>
</div>
</div>
</template>

<script>
export default {
  props: ['indentDetails'],
};
</script>
